'use client';
import Image from '@/components/image';
import NextLink from '@/components/next-link';
import usePromotionImpression from '@/hooks/usePromotionImpression';
import { handleLinkByTypeV2 } from '@/utils/config';
import { event_banner_click } from '@/utils/gtm';
import { fireSelectPromotion } from '@/utils/gtm/helper';
import { signIn, useSession } from 'next-auth/react';
import { useLocale } from 'next-intl';

const BannerCard = ({
  img,
  url,
  alt,
  aspectRatio,
  width,
  height,
  type,
  title,
  sliderKey = '',
  sectionId = '',
  target = '_self',
  promotion,
}) => {
  const { data: session } = useSession();
  const locale = useLocale();
  const promotionRef = usePromotionImpression(promotion);

  const gatedByLogin = !session?.user && url.includes('prescription');
  const href = gatedByLogin ? '#' : handleLinkByTypeV2(url, type);

  const handleClick = (e) => {
    event_banner_click({
      banner_id: String(sectionId || 1),
      banner_name: alt || title || 'Banner',
      banner_category: url,
      section: sliderKey,
    });
    fireSelectPromotion(promotion, href, locale);

    if (gatedByLogin) {
      e.preventDefault();
      signIn(undefined, { callbackUrl: '/prescription' });
    }
  };

  return (
    <NextLink
      ref={promotionRef}
      target={gatedByLogin ? target : '_self'}
      href={href}
      className={`w-full aspect-[${aspectRatio}] relative overflow-hidden rounded-lg`}
      aria-label={alt || 'banner image'}
      onClick={handleClick}
    >
      <Image
        src={img}
        className={`relative h-auto w-full object-fill transition-transform duration-500 hover:scale-[1.01]`}
        alt={alt || `${title} brand`}
        width={width || 800}
        height={height}
      />
    </NextLink>
  );
};

export default BannerCard;
